// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"8c5f185c","705":"610a8155","821":"f5ef0a5e"}[chunkId] + ".chunk.js";
};